import MultiSelectDropDownListFactory from '@/Factories/ControlFactories/MultiSelectDropDownListFactory';
import ComponentManager from '@/Management/ComponentManager';

export default class CustomMultiSelectDropDownListFactory extends MultiSelectDropDownListFactory {

    public constructor(params: any) {
        super(params);
    }

}

ComponentManager.setFactory('CustomMultiSelectDropDownList', CustomMultiSelectDropDownListFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');